/* eslint-disable prefer-template */
import { GET_MY } from '../../containers/App/constants';
import {
  GET_KANBAN_BOARDS,
  KANBAN_BOARDS_REFRESH,
  KANBAN_BOARDS_SET_ACTIVE_BOARD,
  PREPARE_KANBAN_PROGRESS_BAR,
  REQUEST_CACHE_STATUS,
  REQUEST_KANBAN_BOARD,
  REQUEST_KANBAN_BOARDS,
  REQUEST_KANBAN_BOARD_COLUMN_CELLS,
  REQUEST_KANBAN_BOARD_COLUMN_CELLS_CACHE_REFRESH,
  REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK,
  REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_FROM_CACHE,
  SET_KANBAN_PROGRESS_BAR_VALUE,
  UPDATE_KANBAN_FILTERS,
  APPLY_KANBAN_FILTERS,
  RESET_KANBAN_FILTER,
  RESET_ALL_KANBAN_FILTERS,
  TOGGLE_KANBAN_COMPANY_MODAL,
  SET_KANBAN_COLUMN_SORT,
} from './constants';

export function kanbanMock(data, callback) {
  return {
    type: GET_MY,
    work: data.work,
    gate: data.gate,
    post: data.post,
    path: `boards/mock`,
    callback,
  };
}

export function fetchKanbanBoards(callback) {
  return {
    type: GET_MY,
    id: REQUEST_KANBAN_BOARDS,
    work: REQUEST_KANBAN_BOARDS,
    gate: REQUEST_KANBAN_BOARDS,
    path: `boards`,
    callback,
  };
}

export function getKanbanBoards() {
  return {
    type: GET_KANBAN_BOARDS,
  };
}

export function fetchKanbanBoard(boardId, callback) {
  if (!boardId) {
    throw 'requires boardId';
  }
  return {
    type: GET_MY,
    id: REQUEST_KANBAN_BOARD,
    boardId,
    work: REQUEST_KANBAN_BOARD + boardId,
    gate: REQUEST_KANBAN_BOARD + boardId,
    path: `boards/${boardId}`,
    callback,
  };
}

export function fetchKanbanBoardColumnCells(boardId, columnId, callback) {
  return {
    type: REQUEST_KANBAN_BOARD_COLUMN_CELLS,
    //id: REQUEST_KANBAN_BOARD_COLUMN_CELLS,
    boardId,
    columnId,
    work: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + columnId,
    gate: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + columnId,
    path: `boards/${boardId}/columns/${columnId}/cells/from-cache`,
    putOnComplete: [
      {
        type: REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK,
        boardId,
        columnId,
      },
    ],
    callback,
  };
}

//should only be called from SAGA
export function fetchKanbanBoardColumnCellsFiltered(boardId, columnId, filterString, callback) {
  return {
    type: GET_MY,
    id: REQUEST_KANBAN_BOARD_COLUMN_CELLS,
    boardId,
    columnId,
    work: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + columnId,
    gate: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + columnId,
    path: `boards/${boardId}/columns/${columnId}/cells/from-cache/${filterString}`,
    putOnComplete: [
      {
        type: REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK,
        boardId,
        columnId,
      },
    ],
    callback,
  };
}

export function forceKanbanCacheRefresh(boardId, columnId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_KANBAN_BOARD_COLUMN_CELLS_CACHE_REFRESH,
    boardId,
    columnId,
    work: REQUEST_KANBAN_BOARD_COLUMN_CELLS_CACHE_REFRESH + boardId + '_' + columnId,
    gate: REQUEST_KANBAN_BOARD_COLUMN_CELLS_CACHE_REFRESH + boardId + '_' + columnId,
    path: `boards/${boardId}/columns/${columnId}/cells/force-cache-update`,
    putOnComplete: [fetchKanbanBoardColumnCells(boardId, columnId)],
    callback,
  };
}

export function fetchKanbanCacheStatus() {
  return {
    type: GET_MY,
    id: REQUEST_CACHE_STATUS,
    work: REQUEST_CACHE_STATUS,
    gate: REQUEST_CACHE_STATUS,
    path: `boards/cache-status`,
  };
}
export function fetchKanbanBoardColumnCellsFromCache(boardId, columnId, callback, limit = 40) {
  //todo: think of a smart way to handle limits ?
  // maybe solution is working with pagination?

  return {
    type: REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_FROM_CACHE,
  };
}

export function fetchQueueKanbanBoardColumnCells(boardId, columnId, callback, limit = 40) {
  //todo: think of a smart way to handle limits ?
  // maybe solution is working with pagination?

  if ([3, 4, 5, 9, 10, 26, 27, 28, 29, 31, 33, 35].indexOf(boardId) > -1) {
    limit = 200;
  }
  if ([82, 65, 87, 86, 22, 603].indexOf(columnId) > -1) {
    limit = 200;
  }

  return {
    type: REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS,
    boardId,
    columnId,
    callback,
    limit,
  };
}

export function createBoard(label, callback) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARDS,
    gate: REQUEST_KANBAN_BOARDS + 'create',
    put: {
      label,
    },
    path: `boards`,
    putOnComplete: [fetchKanbanBoards()],
    callback,
  };
}
export function deleteBoard(boardId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARDS,
    gate: REQUEST_KANBAN_BOARDS + 'delete' + boardId,
    delete: {},
    path: `boards/${boardId}`,
    putOnComplete: [fetchKanbanBoards()],
    callback,
  };
}

export function performAction(actionId, entityId, payload, callback, ignoreConditions) {
  let path = `boards/tmp/actions/${actionId}/perform`;
  if (ignoreConditions) {
    path += '?ignoreConditions=true';
  }
  return {
    type: GET_MY,
    work: [REQUEST_KANBAN_BOARD_PERFORM_ACTION, REQUEST_KANBAN_BOARD_PERFORM_ACTION + actionId + '_' + entityId],
    gate: REQUEST_KANBAN_BOARD_PERFORM_ACTION + actionId + '_' + entityId,
    path,
    post: {
      actionId,
      entityId,
      payload,
    },
    putOnComplete: [refreshBoards()],
    callback,
  };
}

export function columnSortUp(boardId, columnId) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION + columnId,
    path: `boards/${boardId}/columns/${columnId}/sort/up`,
    post: {
      boardId,
      columnId,
    },
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}

export function columnSortDown(boardId, columnId) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION + columnId,
    path: `boards/${boardId}/columns/${columnId}/sort/down`,
    post: {
      boardId,
      columnId,
    },
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}

export function columnDelete(boardId, columnId) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION + columnId,
    path: `boards/${boardId}/columns/${columnId}`,
    delete: {
      boardId,
      columnId,
    },
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}
export function columnSetAction(boardId, columnId, actionId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION + columnId,
    path: `boards/${boardId}/columns/${columnId}/actions`,
    put: {
      actionsIds: [actionId],
    },
    callback,
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}

export function addColumn(boardId, label, callback) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION + 'create',
    path: `boards/${boardId}/column`,
    put: { label },
    callback,
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}

export function editColumnName(boardId, columnId, label, callback) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION + columnId,
    path: `boards/${boardId}/columns/${columnId}/rename`,
    post: { label },
    callback,
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}

export function editBoardName(boardId, name, callback) {
  return {
    type: GET_MY,
    work: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    gate: REQUEST_KANBAN_BOARD_COLUMN_OPERATION,
    path: `boards/${boardId}/rename`,
    post: { label: name },
    callback,
    putOnComplete: [fetchKanbanBoard(boardId)],
  };
}

export function refreshBoards() {
  return {
    type: KANBAN_BOARDS_REFRESH,
  };
}

export function setActiveBoard(boardId) {
  return {
    type: KANBAN_BOARDS_SET_ACTIVE_BOARD,
    boardId,
  };
}

export function prepareKanboardProgressBar(targetType, target, boardId) {
  return {
    type: PREPARE_KANBAN_PROGRESS_BAR,
    targetType,
    target,
    boardId,
  };
}

export function setProgressBarValue(boardId, targetType, targetId, progress) {
  return {
    type: SET_KANBAN_PROGRESS_BAR_VALUE,
    targetType,
    targetId,
    boardId,
    progress,
  };
}

export function toggleKanbanCompanyModal(entityId, actionName = null) {
  return {
    type: TOGGLE_KANBAN_COMPANY_MODAL,
    entityId,
    actionName,
  };
}

export function updateKanbanFilter(filter) {
  return {
    type: UPDATE_KANBAN_FILTERS,
    filter,
  };
}

export function resetKanbanFilter(filter) {
  return {
    type: RESET_KANBAN_FILTER,
    filter,
  };
}

export function clearKanbanFilters() {
  return {
    type: RESET_ALL_KANBAN_FILTERS,
  };
}

export function applyKanbanFilters() {
  return {
    type: APPLY_KANBAN_FILTERS,
  };
}

export function setKanbanColumnSort(columnId, sortBy, desc) {
  return {
    type: SET_KANBAN_COLUMN_SORT,
    columnId,
    sortBy,
    desc,
  };
}
